import React from "react";
import classes from "./heroCard.module.css";
import videosrc from "../../assets/videoplayback.webm";
import styled from "styled-components";
import { mobile, laptopsm, desktop } from "../../responsive";
const VideoCard = () => {
  const Video = styled.video`
    ${desktop({ maxWidth: "100vw", maxHeight: "100vh" })};
    filter: grayscale(1);
    object-fit: "fill";
    ${laptopsm({ maxWidth: "100%", maxHeight: "100%" })};
    ${mobile({ display:"none"})};
  `;
  return (
    <Video
      className={classes.videoContainer}
      loop
      autoPlay
      muted
      src={videosrc}
    />
  );
};

export default VideoCard;
